import { z } from 'zod';
/** Own file (not ai-features.ts): app-registry needs the tier, and
 *  ai-features → organization → app-registry would cycle. */ export const AiTierSchema = z.enum([
    'high',
    'low'
]);
export const isAiTier = (value)=>AiTierSchema.safeParse(value).success;
/**
 * The tier a feature or app model slot declares. `decision` runs `decide()`
 * on the default decision model; it is never a stored override, so an
 * operator pins such a consumer to a chat model or tier and clears the pin to
 * return it to the decision model.
 */ export const AiConsumerTierSchema = z.enum([
    ...AiTierSchema.options,
    'decision'
]);

//# sourceMappingURL=ai-tier.js.map